<template>
    <div class="guide-select-box">
        <span @click="handleHelp" class="item">使用帮助</span>
        <span @click="handleUser" class="item">帮助中心</span>
    </div>
</template>

<script>
    import LocalStorage from '../../../../../../utils/localStorageUtil'
    export default {
        name: "guide-box",
        methods: {
            handleHelp(){
                LocalStorage.removeGuideStep()
                this.$store.state.guideStep = 'start'
            },
            handleUser(){
                this.$message.warning('还在装修中...马上就会开放啦~')
            }
        }
    }
</script>

<style lang="scss" scoped>
.guide-select-box{
    position: absolute;
    left: -121px;
    bottom: 14px;
    width: 121px;
    height: 100px;
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border: 1px solid #E4E7ED;
    border-radius: 6px;

    &:before{
        content: '';
        position: absolute;
        right: -8px;
        bottom: 8px;
        width: 0;
        height: 0;
        border-left: 8px solid white;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
    }

    .item{
        line-height: 50px;
        font-size: 14px;
        font-weight: 400;
        color: #909399;
        padding-left: 20px;
        cursor: pointer;

        &:hover{
            color: #606266;
        }

        &:first-child{
            border-bottom: 1px solid #EBEEF5;
        }
    }
}
</style>
